<div class="header">
    <h2>Inventory Match (Mark <span *ngIf="!markOwned">Not-</span>Owned)</h2>
</div>
<ng-container *ngIf="selectedInventoryCard; else noInventory">
    <div class="wrapper">
        <app-card-image [card]="selectedInventoryCard" [width]="300" [quantity]="selectedInventoryCard.quantity"
                        [clickable]="false" [hoverable]="false" [draggable]="false"></app-card-image>
        <div class="details">
            <div class="inventory-settings">
                <p>
                    Note: Changes made here will modify the card in your inventory.
                </p>
                <mat-form-field class="number-input">
                    <mat-label>Current Inventory Quantity</mat-label>
                    <input matInput type="number" [value]="selectedInventoryCard.quantity.toString(10)" (change)="onQuantityChange($event.target.value)">
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Quality</mat-label>
                    <mat-select [value]="selectedInventoryCard.quality" (selectionChange)="onQualityChange($event.value)">
                        <mat-option
                                *ngFor="let quality of ['Mint', 'Near Mint', 'Excellent', 'Good', 'Light Played', 'Played', 'Poor']"
                                [value]="quality">{{quality}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-checkbox [checked]="selectedInventoryCard.isFoil" (change)="onFoilChange($event.checked)">Foil?</mat-checkbox>
            </div>
            <div class="buttons">
                <button mat-raised-button color="primary" (click)="saveInventoryChanges()"><mat-icon>check</mat-icon> Save</button>
                <button mat-raised-button color="warn" (click)="cancelInventoryChanges()"><mat-icon>cancel</mat-icon> Cancel</button>
            </div>
        </div>
    </div>
</ng-container>
<ng-template #noInventory>
    <div>
        <h3>No matching inventory found!</h3>
        <p>
            Would you like to select a card to add to your inventory?
        </p>
        <div class="buttons">
            <button mat-raised-button color="primary" (click)="pickNewInventory()"><mat-icon>check</mat-icon> Pick Card To Add</button>
            <button mat-raised-button color="warn" (click)="cancelInventoryChanges()"><mat-icon>cancel</mat-icon> Cancel</button>
        </div>
    </div>
</ng-template>
